import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.scss']
})
export class CertificationComponent implements OnInit {

  cards = [
    {
      icon: 'img/live-courses/industry.png',
      title: 'Industry-Endorsed',
      description: 'Recognized by hiring managers and tech leaders'
    },
    {
      icon: 'img/live-courses/career-bosting.png',
      title: 'Career Boosting',
      description: 'Showcase your skills on LinkedIn, GitHub, and job portals'
    },
    {
      icon: 'img/live-courses/skill-validation.png',
      title: 'Skill Validation',
      description: 'Proof of your expertise in enrolled program'
    },
    {
      icon: 'img/live-courses/exclusive.png',
      title: 'Exclusive Recognition',
      description: 'Join a global network of certified professionals'
    }
  ];

  @Input() certificateImage!: string;
  @Input() link!: string;
  constructor() { }

  ngOnInit(): void {
  }

}
